<div class="login-limit-reminder-alert-container">
	<div class="login-limit-reminder-alert-header">
		<img obgImageContent="responsible-gaming.login-limit" obgImageContentGroup="common" />
		<h1
			class="login-limit-reminder-alert-header-text"
			[innerHTML]="'responsible-gaming.login-limit.title' | translate"
		></h1>
	</div>

	<div class="login-limit-reminder-alert-content">
		<p
			class="login-limit-reminder-alert-container-content-strong"
			[innerHTML]="'responsible-gaming.login-limit-notification' | translate"
		></p>
		<p
			class="login-limit-reminder-alert-container-content-message"
			[innerHTML]="'responsible-gaming.login-limit-notification.text-remaining'| translate: {
		loginsLeft: loginsLeft
		}"
		></p>
	</div>
	<div class="login-limit-reminder-alert-container-button-container">
		<button mat-flat-button color="accent" (click)="closeModal()">{{ 'general.close' | translate }}</button>
	</div>
</div>
